// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"97de4fad","364":"4e94d46f","750":"36087b75","977":"afa6e2cb"}[chunkId] + ".chunk.js";
};